import React from 'react';
import { UsersIcon, HeartIcon, MusicIcon } from 'lucide-react';
export function About() {
  return <section id="about" className="py-20 bg-white" data-id="element-16">
      <div className="container mx-auto px-4" data-id="element-17">
        <div className="text-center mb-16" data-id="element-18">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-19">
            Here's Our Plan
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-20">
            We aim to create a supportive environment where musicians with
            autism and intellectual disabilities can develop their talents and
            share their unique musical perspectives.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-10" data-id="element-21">
          <div className="bg-indigo-50 p-8 rounded-lg text-center" data-id="element-22">
            <div className="inline-block p-4 bg-indigo-100 rounded-full mb-6" data-id="element-23">
              <UsersIcon size={32} className="text-indigo-600" data-id="element-24" />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-25">
              Who We'll Serve
            </h3>
            <p className="text-gray-600" data-id="element-26">
              A collective of adult musicians with autism and intellectual
              disabilities, guided by experienced mentors and music
              professionals in the Cherry Hill, NJ area.
            </p>
          </div>
          <div className="bg-indigo-50 p-8 rounded-lg text-center" data-id="element-27">
            <div className="inline-block p-4 bg-indigo-100 rounded-full mb-6" data-id="element-28">
              <HeartIcon size={32} className="text-indigo-600" data-id="element-29" />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-30">
              Our Mission
            </h3>
            <p className="text-gray-600" data-id="element-31">
              To provide opportunities for musicians with autism and
              intellectual disabilities to develop their talents, collaborate,
              and perform in supportive environments as an engaging alternative
              to traditional day programs.
            </p>
          </div>
          <div className="bg-indigo-50 p-8 rounded-lg text-center" data-id="element-32">
            <div className="inline-block p-4 bg-indigo-100 rounded-full mb-6" data-id="element-33">
              <MusicIcon size={32} className="text-indigo-600" data-id="element-34" />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-35">
              What We'll Do
            </h3>
            <p className="text-gray-600" data-id="element-36">
              We plan to organize regular practice sessions, workshops, and
              public performances that showcase the unique talents of our
              members.
            </p>
          </div>
        </div>
        <div className="mt-16 bg-gray-50 p-8 rounded-lg" data-id="element-37">
          <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-38">
            Important Note
          </h3>
          <p className="text-gray-700" data-id="element-39">
            Our collective will be designed for adults with some existing
            musical abilities. We are not a music therapy program or a
            beginner's music class. We'll focus on developing the talents of
            musicians who are ready to collaborate and perform. This program is
            currently in the planning stage - we're gathering interest to help
            secure an agency partner.
          </p>
        </div>
      </div>
    </section>;
}